"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var ToggleButton_1 = require("./ToggleButton");
var SidebarSection_1 = require("./SidebarSection");
var Sidebar = function (_a) {
    var _b = _a.el, Element = _b === void 0 ? 'div' : _b, className = _a.className, localStorageKey = _a.localStorageKey, children = _a.children, rest = __rest(_a, ["el", "className", "localStorageKey", "children"]);
    var breakpoint = 992;
    var hoverDelay = 300;
    var hoverTimeout = react_1.useRef();
    var sidebarRef = react_1.useRef();
    var pointerId = react_1.useRef();
    var getInitialOpen = function () {
        var wasPreviouslyOpen = typeof window !== 'undefined' &&
            window.localStorage.getItem(localStorageKey);
        return {
            value: wasPreviouslyOpen ? JSON.parse(wasPreviouslyOpen) : true,
            temporary: false,
        };
    };
    var _c = react_1.useState(false), isDisplaySmall = _c[0], setIsDisplaySmall = _c[1];
    var _d = react_1.useState(getInitialOpen()), openOnLargeDisplay = _d[0], setOpenOnLargeDisplay = _d[1];
    var _e = react_1.useState(false), openOnSmallDisplay = _e[0], setOpenOnSmallDisplay = _e[1];
    var isOpen = (isDisplaySmall && openOnSmallDisplay) ||
        (!isDisplaySmall && openOnLargeDisplay.value);
    var isTemporary = isDisplaySmall || (!isDisplaySmall && openOnLargeDisplay.temporary);
    var isTouchScreen = typeof window !== 'undefined' &&
        window.matchMedia('(pointer:coarse)').matches;
    var open = react_1.useCallback(function (options) {
        var _a;
        clearTimeout(hoverTimeout.current);
        if (isDisplaySmall) {
            setOpenOnSmallDisplay(true);
        }
        else {
            setOpenOnLargeDisplay({
                value: true,
                temporary: (_a = options.temporary) !== null && _a !== void 0 ? _a : false,
            });
        }
    }, [isDisplaySmall]);
    var close = react_1.useCallback(function () {
        clearTimeout(hoverTimeout.current);
        if (isDisplaySmall) {
            setOpenOnSmallDisplay(false);
        }
        else {
            setOpenOnLargeDisplay({
                value: false,
                temporary: false,
            });
        }
    }, [isDisplaySmall]);
    var handlePointerEnter = function (e) {
        if (e.pointerType === 'mouse') {
            clearTimeout(hoverTimeout.current);
            if (isOpen)
                return;
            hoverTimeout.current = setTimeout(function () { return open({ temporary: true }); }, hoverDelay);
        }
    };
    var handlePointerLeave = function (e) {
        var _a;
        if (e.pointerType === 'mouse') {
            clearTimeout(hoverTimeout.current);
            if (!isOpen || (isOpen && !isTemporary))
                return;
            if (e.relatedTarget.nodeType &&
                ((_a = sidebarRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget)))
                return;
            hoverTimeout.current = setTimeout(function () { return close(); }, hoverDelay);
        }
    };
    var handlePointerDown = function (e) {
        if (isDisplaySmall && e.pointerType === 'touch')
            pointerId.current = e.pointerId;
    };
    var handlePointerUp = function (e) {
        if (isDisplaySmall &&
            e.pointerType === 'touch' &&
            e.pointerId === pointerId.current) {
            if (isOpen)
                return;
            open({ temporary: true });
            pointerId.current = undefined;
        }
    };
    var calcDisplaySmall = function () {
        var windowWidth = Math.min(window.innerWidth, window.outerWidth);
        return windowWidth < breakpoint;
    };
    var SidebarClasses = classnames_1.default('Sidebar', className, {
        'Sidebar--collapsed': !isOpen,
        'Sidebar--temporary': isOpen && isTemporary,
        'Sidebar--touch': isTouchScreen,
    });
    var toggleButtonClasses = classnames_1.default('Sidebar__toggle-button', {
        'Sidebar__toggle-button-visible': isTemporary || isTouchScreen || !isOpen,
    });
    react_1.useEffect(function () {
        var handleWindowResize = function () { return setIsDisplaySmall(calcDisplaySmall()); };
        window.addEventListener('resize', utilities_1.debounce(handleWindowResize, 150));
        handleWindowResize();
        return function () { return window.removeEventListener('resize', handleWindowResize); };
    }, []);
    react_1.useEffect(function () {
        if (!openOnLargeDisplay.temporary) {
            localStorage.setItem(localStorageKey, JSON.stringify(openOnLargeDisplay.value));
        }
    }, [openOnLargeDisplay, localStorageKey]);
    react_1.useEffect(function () {
        var handleTapOutside = function (e) {
            var _a;
            if (isOpen &&
                isTemporary &&
                !((_a = sidebarRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                close();
            }
        };
        window.addEventListener('touchend', handleTapOutside);
        return function () { return window.removeEventListener('touchend', handleTapOutside); };
    }, [isOpen, isTemporary, close]);
    react_1.useEffect(function () {
        return function () { return clearTimeout(hoverTimeout.current); };
    }, []);
    return (react_1.default.createElement(Element, __assign({ className: SidebarClasses, ref: sidebarRef }, rest),
        react_1.default.createElement("div", { className: "Sidebar__wrapper" },
            react_1.default.createElement(ToggleButton_1.ToggleButton, { className: toggleButtonClasses, isTouchScreen: isTouchScreen, isDisplaySmall: isDisplaySmall, openOnLargeDisplay: openOnLargeDisplay, openOnSmallDisplay: openOnSmallDisplay, open: open, close: close, onPointerEnter: function () { return clearTimeout(hoverTimeout.current); }, onPointerLeave: handlePointerLeave }),
            react_1.default.createElement("div", { className: "Sidebar__content-wrapper", onPointerEnter: handlePointerEnter, onPointerLeave: handlePointerLeave, onPointerDown: handlePointerDown, onPointerUp: handlePointerUp },
                react_1.default.createElement("div", { className: "Sidebar__content" }, children)))));
};
exports.Sidebar = Sidebar;
exports.Sidebar.Section = SidebarSection_1.SidebarSection;
//# sourceMappingURL=Sidebar.js.map